<template>
  <div id="terminal"/>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue';
import { Terminal } from 'xterm';
// noinspection JSUnresolvedReference
import { AttachAddon } from '@xterm/addon-attach';
// noinspection JSUnresolvedReference
import { FitAddon } from '@xterm/addon-fit';
import 'xterm/css/xterm.css';

const term = ref(null);
const fitAddon = ref(null);
const socket = ref(null);
const termResizeObs = ref(null);

const props = defineProps([
  'wsurl'
]);
const emit = defineEmits([
  'connected',
  'not-connected'
]);

function initTerminal(wsurl) {
  const t = new Terminal({ cols: 165, rows: 30 });
  // FIXME: This code sometimes spam the terminal with TEXT after a resize
  t.onResize(({ cols, rows }) => {
    if (ws.readyState === ws.OPEN) {
      const terminalSize = {
        Width: cols,
        Height: rows,
      };
      ws.send("\x04" + JSON.stringify(terminalSize));
    }
  });
  const ws = new WebSocket(wsurl);
  ws.addEventListener('open', (_e) => emit('connected'));
  ws.addEventListener('close', (_e) => emit('not-connected'));
  ws.addEventListener('error', (_e) => emit('not-connected'));
  socket.value = ws;
  const attachAddon = new AttachAddon(socket.value);
  t.loadAddon(attachAddon);
  const fitAdd = new FitAddon();
  t.loadAddon(fitAdd);
  fitAdd.fit();

  fitAddon.value = fitAdd;
  t.open(document.getElementById('terminal'));
  term.value = t;
  // FIXME: This approach is incomplete because the row number is not changed
  termResizeObs.value = new ResizeObserver(function (_entries) {
    // since we are observing only a single element, so we access the first element in entries array
    try {
      if (fitAddon.value !== null) fitAddon.value.fit();
    } catch (e) {
      console.error(e);
    }
  });
  // start observing for resize
  termResizeObs.value.observe(document.querySelector("#terminal"));
}

onMounted(() => {
  if (props.wsurl !== null) {
    initTerminal(props.wsurl);
  }
});

function dispose() {
  if (termResizeObs.value !== null) {
    termResizeObs.value.disconnect();
    termResizeObs.value = null;
  }
  if (fitAddon.value !== null) {
    fitAddon.value.dispose();
    fitAddon.value = null;
  }
  if (term.value !== null) {
    term.value.dispose();
    term.value = null;
  }
  if (socket.value !== null) {
    socket.value.close();
    socket.value = null;
  }
}

onUnmounted(() => {
  dispose();
});

watch(() => props.wsurl, (newWSUrl) => {
  if (term.value !== null) {
    dispose();
  }
  if (newWSUrl !== null) {
    initTerminal(String(newWSUrl));
  }
});


</script>

<style scoped>

</style>
